import {
  BrowseRoyaltyFreeTile,
  DistributeMusicTile,
  MusicGeneratorTile,
  TextToMusicTile,
} from './components';
import { StyledContainer } from './styled';

const FeatureTilesContainer = () => (
  <StyledContainer>
    <MusicGeneratorTile />
    <TextToMusicTile />
    <BrowseRoyaltyFreeTile />
    <DistributeMusicTile />
  </StyledContainer>
);
export default FeatureTilesContainer;
